(function() { window.GUID_3a6764f7_f9d7_41c0_99f0_e79468c0397e = { getGuid: function() { return "3a6764f7-f9d7-41c0-99f0-e79468c0397e"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        var ImageCropperAddons;
        (function (ImageCropperAddons) {
            class ImageCropperMobile extends ImageCropperAddons.Base {
                OnDispose() {
                    if (this.gestures != null)
                        this.gestures.Dispose();
                }
                /**
                 * Handle Touh gestures for Drag and Zoom and return callback with requestAnimationFrame Optimisation
                 * @param element
                 * the element to bind gestures detection events to.
                 * @param ScaleCallback
                 * return a scale in a delta format like mouse wheel and the center position of the 2 fingers (scale: number, center: Point)
                 * @param MoveCallback
                 * return the moving distance between 2 animation frame.
                 */
                constructor(mainHelper, element, imageContainer, ScaleCallback, moveCallbacks) {
                    super(mainHelper);
                    this.imageContainer = imageContainer;
                    this.ScaleCallback = ScaleCallback;
                    this.eventNamespace = "imagecropper-mobile";
                    //#region Handle Drag
                    this.handleDragStart = (evt) => {
                        //evt.preventDefault();
                        this.log.Log(() => { CS.Helper.log('ImageCropper', "Drag Start", evt); }, 1000);
                        if (evt.touches && evt.touches.length > 1) {
                            return;
                        }
                        // Add Temporary Mouse Listeners
                        document.addEventListener('mousemove', this.handleDragMove, true);
                        document.addEventListener('mouseup', this.handleDragEnd, true);
                        this.initialTouchPos = this.getGesturePointFromEvent(evt);
                        this.moveCallbacks.DragStartCallback(this.initialTouchPos);
                    };
                    this.handleDragEnd = (evt) => {
                        //evt.preventDefault();
                        this.log.Log(() => { CS.Helper.log('ImageCropper', "DragEnd", evt); }, 1000);
                        if (evt.touches && evt.touches.length > 0) {
                            return;
                        }
                        this.rafPending = false;
                        // Remove Temporary Mouse Listeners
                        document.removeEventListener('mousemove', this.handleDragMove, true);
                        document.removeEventListener('mouseup', this.handleDragEnd, true);
                        this.initialTouchPos = null;
                        this.moveCallbacks.DragEndCallback(this.getGesturePointFromEvent(evt));
                    };
                    this.handleDragMove = (evt) => {
                        //evt.preventDefault();
                        //this.gestures.Touchmove(evt);
                        if (!this.initialTouchPos) {
                            return;
                        }
                        this.lastTouchPos = this.getGesturePointFromEvent(evt);
                        if (this.rafPending) {
                            return;
                        }
                        this.rafPending = true;
                        window.requestAnimationFrame(() => { this.onAnimFrame(); });
                    };
                    //Callback of requestAnnimationFrame for drag
                    this.onAnimFrame = () => {
                        if (!this.rafPending) {
                            return;
                        }
                        var differenceInX = this.lastTouchPos.X - this.initialTouchPos.X;
                        var differenceInY = this.lastTouchPos.Y - this.initialTouchPos.Y;
                        //this.initialTouchPos = this.lastTouchPos;
                        let moveDelta = { X: differenceInX, Y: differenceInY };
                        //console.debug("onAnimFrame ", moveDelta);
                        if (differenceInX != 0 && differenceInY != 0)
                            this.moveCallbacks.MoveCallback(moveDelta);
                        this.rafPending = false;
                    };
                    //#endregion
                    //#region Handle Zoom
                    this.zoomVars = {
                        lastScale: 1,
                        nthZoom: 0,
                        lastZoomCenter: null,
                        hasInteraction: false,
                        newScale: 0,
                        animFrameRequested: false,
                        lastDistance: 0
                    };
                    this.handleZoom = (event, distance) => {
                        if (this.zoomVars.animFrameRequested)
                            return;
                        this.zoomVars.animFrameRequested = true;
                        window.requestAnimationFrame(() => {
                            if (this.zoomVars.lastDistance == 0) {
                                this.zoomVars.lastDistance = distance;
                                this.zoomVars.animFrameRequested = false;
                                return;
                            }
                            var difference = distance - this.zoomVars.lastDistance;
                            this.zoomVars.lastDistance = distance;
                            // a relative scale factor is used
                            var touchCenter = this.getTouchCenter(this.getTouches(event)), scale = difference / this.zoomVars.lastScale;
                            this.zoomVars.lastScale = distance;
                            // the first touch events are thrown away since they are not precise
                            this.zoomVars.nthZoom += 1;
                            if (this.zoomVars.nthZoom > 3) {
                                this.ScaleCallback(scale, touchCenter);
                                //this.drag(touchCenter, this.gestureVars.lastZoomCenter);
                            }
                            this.zoomVars.lastZoomCenter = touchCenter;
                            this.zoomVars.animFrameRequested = false;
                        });
                    };
                    this.handleZoomEnd = (event) => {
                        this.log.Log(() => { CS.Helper.log('ImageCropper', "ZoomEnd"); }, 1000);
                        this.zoomVars.nthZoom = 0;
                        this.zoomVars.lastDistance = 0;
                        this.zoomVars.animFrameRequested = false;
                    };
                    this.handleZoomStart = (event) => {
                        this.zoomVars.lastScale = 1;
                        this.zoomVars.nthZoom = 0;
                        this.zoomVars.lastZoomCenter = null;
                        this.zoomVars.hasInteraction = true;
                        this.zoomVars.lastDistance = 0;
                        this.log.Log(() => { CS.Helper.log('ImageCropper', "ZoomStart"); }, 1000);
                    };
                    this.element = element;
                    this.moveCallbacks = moveCallbacks;
                    //this.registerEvents(Element);
                    this.gestureObj = {
                        canDrag: () => true,
                        enabled: true,
                        isDoubleTap: false,
                        update: () => { },
                        onZoom: this.handleZoom,
                        onZoomEnd: this.handleZoomEnd,
                        onZoomStart: this.handleZoomStart,
                        onDrag: this.handleDragMove,
                        onDragStart: this.handleDragStart,
                        onDragEnd: this.handleDragEnd
                    };
                    this.gestures = new detectGestures(element, this.gestureObj);
                    this.log = CS.Debug.GroupedLog.Get("ImageCropper_Gesture", "ImageCropper Touch", true, false);
                }
                //#endregion
                getGesturePointFromEvent(evt) {
                    var point = { X: 0, Y: 0 };
                    if (evt.targetTouches && evt.targetTouches.length) {
                        //failback evt.targetTouches["0"] to evt.targetTouches[0]
                        var targetTouches = this.gestures.TargetTouches(evt.targetTouches);
                        // Prefer Touch Events
                        point.X = targetTouches[0].X;
                        point.Y = targetTouches[0].Y;
                    }
                    else {
                        // Either Mouse event or Pointer Event
                        point.X = evt.clientX;
                        point.Y = evt.clientY;
                    }
                    return point;
                }
                /**
                 * Calculates the touch center of multiple touches
                 * @param touches
                 * @return {Object}
                 */
                getTouchCenter(touches) {
                    return this.getVectorAvg(touches);
                }
                /**
                 * Calculates the average of multiple vectors (x, y values)
                 */
                getVectorAvg(vectors) {
                    return {
                        X: vectors.map(function (v) { return v.x; }).reduce(this.sum) / vectors.length,
                        Y: vectors.map(function (v) { return v.y; }).reduce(this.sum) / vectors.length
                    };
                }
                /**
                * Returns the touches of an event relative to the container offset
                * @param event
                * @return array touches
                */
                getTouches(event) {
                    var rect = this.imageContainer.parentElement.getBoundingClientRect();
                    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                    var scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;
                    var posTop = rect.top + scrollTop;
                    var posLeft = rect.left + scrollLeft;
                    return Array.prototype.slice.call(event.touches).map(function (touch) {
                        return {
                            X: touch.pageX - posLeft,
                            Y: touch.pageY - posTop,
                        };
                    });
                }
                sum(a, b) {
                    return a + b;
                }
            }
            ImageCropperAddons.ImageCropperMobile = ImageCropperMobile;
            class detectGestures {
                constructor(Element, target) {
                    this.Element = Element;
                    this.interaction = null;
                    this.fingers = 0;
                    this.lastTouchStart = null;
                    this.startTouches = null;
                    this.firstMove = true;
                    this.touchStart = (event) => {
                        this.log.Log(() => { CS.Helper.log('ImageCropper', "Touch Start", event); }, 1000);
                        if (this.target.enabled) {
                            this.firstMove = true;
                            this.fingers = event.touches.length;
                            this.detectDoubleTap(event);
                        }
                    };
                    this.touchmove = (event) => {
                        if (this.target.enabled && !this.target.isDoubleTap) {
                            if (this.firstMove) {
                                this.updateInteraction(event);
                                if (this.interaction) {
                                    //this.cancelEvent(event);
                                }
                                this.startTouches = this.TargetTouches(event.touches);
                            }
                            else {
                                switch (this.interaction) {
                                    case 'zoom':
                                        if (this.startTouches.length == 2 && event.touches.length == 2) {
                                            if (this.target.onZoom != null)
                                                this.target.onZoom(event, this.calculateScale(this.startTouches, this.TargetTouches(event.touches)));
                                        }
                                        break;
                                    case 'drag':
                                        if (this.target.onDrag != null)
                                            this.target.onDrag(event);
                                        break;
                                }
                                if (this.interaction) {
                                    //this.cancelEvent(event);
                                    this.target.update();
                                }
                            }
                            this.firstMove = false;
                        }
                    };
                    this.touchEnd = (event) => {
                        if (this.target.enabled) {
                            this.fingers = event.touches.length;
                            this.updateInteraction(event);
                        }
                    };
                    this.target = target;
                    this.registerEvents();
                    this.log = CS.Debug.GroupedLog.Get("DetectGesture", "ImageCropper Gesture", true, false);
                }
                registerEvents() {
                    this.Element.addEventListener('touchstart', this.touchStart);
                    this.Element.addEventListener('touchmove', this.touchmove);
                    this.Element.addEventListener('touchend', this.touchEnd);
                    window.addEventListener;
                }
                Dispose() {
                    this.Element.removeEventListener('touchstart', this.touchStart);
                    this.Element.removeEventListener('touchmove', this.touchmove);
                    this.Element.removeEventListener('touchend', this.touchEnd);
                }
                //Utils
                arrayFrom(object) {
                    return [].slice.call(object);
                }
                buildElement(str) {
                    // empty string as title argument required by IE and Edge
                    var tmp = document.implementation.createHTMLDocument('');
                    tmp.body.innerHTML = str;
                    return this.arrayFrom(tmp.body.children)[0];
                }
                triggerEvent(el, name) {
                    var event = document.createEvent('HTMLEvents');
                    event.initEvent(name, true, false);
                    el.dispatchEvent(event);
                }
                //\\Util End
                setInteraction(newInteraction, event) {
                    this.log.Log(() => { CS.Helper.log('ImageCropper', "setInteraction", { newInteraction, event, interaction: this.interaction }); }, 1000);
                    if (this.interaction !== newInteraction) {
                        if (this.interaction && !newInteraction) {
                            switch (this.interaction) {
                                case "zoom":
                                    if (this.target.onZoomEnd != null)
                                        this.target.onZoomEnd(event);
                                    break;
                                case 'drag':
                                    if (this.target.onDragEnd != null)
                                        this.target.onDragEnd(event);
                                    break;
                            }
                        }
                        switch (newInteraction) {
                            case 'zoom':
                                if (this.target.onZoomStart != null)
                                    this.target.onZoomStart(event);
                                break;
                            case 'drag':
                                if (this.target.onDragStart)
                                    this.target.onDragStart(event);
                                break;
                        }
                    }
                    this.interaction = newInteraction;
                }
                updateInteraction(event) {
                    this.log.Log(() => { CS.Helper.log('ImageCropper', "updateInteraction", { fingers: this.fingers, event }); }, 1000);
                    if (this.fingers === 2) {
                        this.setInteraction('zoom');
                    }
                    else if (this.fingers === 1 && this.target.canDrag()) {
                        this.setInteraction('drag', event);
                    }
                    else {
                        this.setInteraction(null, event);
                    }
                }
                TargetTouches(touches) {
                    return this.arrayFrom(touches).map((touch) => {
                        return {
                            X: touch.pageX,
                            Y: touch.pageY
                        };
                    });
                }
                getDistance(a, b) {
                    var x, y;
                    x = a.X - b.X;
                    y = a.Y - b.Y;
                    return Math.sqrt(x * x + y * y);
                }
                calculateScale(startTouches, endTouches) {
                    var startDistance = this.getDistance(startTouches[0], startTouches[1]), endDistance = this.getDistance(endTouches[0], endTouches[1]);
                    return endDistance / startDistance;
                }
                cancelEvent(event) {
                    event.stopPropagation();
                    event.preventDefault();
                }
                detectDoubleTap(event) {
                    var time = (new Date()).getTime();
                    if (this.fingers > 1) {
                        this.lastTouchStart = null;
                    }
                    if (time - this.lastTouchStart < 300) {
                        //this.cancelEvent(event);
                        if (this.target.onDoubleTap != null)
                            this.target.onDoubleTap(event);
                        switch (this.interaction) {
                            case "zoom":
                                if (this.target.onZoomEnd != null)
                                    this.target.onZoomEnd(event);
                                break;
                            case 'drag':
                                if (this.target.onDragEnd != null)
                                    this.target.onDragEnd(event);
                                break;
                        }
                    }
                    else {
                        this.target.isDoubleTap = false;
                    }
                    if (this.fingers === 1) {
                        this.lastTouchStart = time;
                    }
                }
            }
        })(ImageCropperAddons = Controls.ImageCropperAddons || (Controls.ImageCropperAddons = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=image-cropper.mobile.js.map
